"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionReadableService = void 0;
var tsyringe_1 = require("tsyringe");
var configurationService_1 = require("../configurationService/configurationService");
var TransactionReadableService = /** @class */ (function () {
    function TransactionReadableService(configurationService) {
        this.configurationService = configurationService;
    }
    TransactionReadableService.prototype.getReadableTransaction = function (_a) {
        var data = _a.data, transaction = _a.transaction;
        var _b = data._method, constant = _b.constant, inputs = _b.inputs, name = _b.name, outputs = _b.outputs, payable = _b.payable, stateMutability = _b.stateMutability, type = _b.type, signature = _b.signature;
        var readableArguments = data.arguments
            .map(function (value, index) {
            return {
                value: value,
                name: inputs[index].name
            };
        });
        var from = transaction.from, to = transaction.to;
        var contractName = this.configurationService.getContractNameFromAddress(to);
        var readableTransaction = {
            contractName: contractName,
            from: from,
            to: to,
            constant: constant,
            inputs: inputs,
            name: name,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability,
            type: type,
            signature: signature,
            arguments: readableArguments
        };
        return readableTransaction;
    };
    ;
    TransactionReadableService = __decorate([
        (0, tsyringe_1.injectable)(),
        __metadata("design:paramtypes", [configurationService_1.ConfigurationService])
    ], TransactionReadableService);
    return TransactionReadableService;
}());
exports.TransactionReadableService = TransactionReadableService;
//# sourceMappingURL=transactionReadableService.js.map